import React from 'react'
import { Box } from '@mui/material'
import { FlexBoxProps } from './_props'
import { mergeSx } from '../../../theme/_utils'

const FlexBox: React.FC<FlexBoxProps> = ({
    justifyContent = 'flex-start',
    alignItems = 'flex-start',
    flexDirection = 'row',
    gap = 0,
    children,
    sx,
    ...boxProps
}) => (
    <Box
        sx={mergeSx([
            {
                display: 'flex',
                justifyContent,
                alignItems,
                flexDirection,
                gap,
            },
            sx,
        ])}
        {...boxProps}
    >
        {children}
    </Box>
)

export default FlexBox
